import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllImportInvoiceTtSlice = createSlice({
    name: "getAllImportInvoiceTt",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllImportInvoiceTtSlice_actions = getAllImportInvoiceTtSlice.actions;
export var fetchData = _getAllImportInvoiceTtSlice_actions.fetchData, fetchDataSuccess = _getAllImportInvoiceTtSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllImportInvoiceTtSlice_actions.fetchDataFailure, resetState = _getAllImportInvoiceTtSlice_actions.resetState;
export default getAllImportInvoiceTtSlice.reducer;
